/**
 * Function used to determine if the item is big in the grid
 * on the mobile version of the carousel.
 *
 * To simplify the layout on other viewports, we remove the first one
 * from the calculation, because it is always big in all sizes
 * and because in tablet and desktop it is placed outside a scrollable area
 *
 * New: we can now take into account extra items indexes. Extra items are
 * **always** big and can be injected at arbitrary positions. This could
 * impact the size calculation, since we could have orphan small items. Extra items
 * are already taken into account in the `realLength` parameter.
 *
 */
export function isBig(
  index: number,
  realLength: number,
  extraItemsIndexes?: number[],
): boolean {
  // First one is always small (the real first one is always big)
  if (index === 1 && realLength > 2) {
    return false
  }
  // If it's just 1 (and no extra items), both are big (regardless of the index)
  if (realLength === 2) {
    return true
  }
  // Every other 3n+1 item is big
  if ((index + 1) % 3 === 0) {
    return true
  }
  // If there is an extra item at the end, the last item is big
  if (
    extraItemsIndexes &&
    extraItemsIndexes.includes(realLength - 1) &&
    index === realLength - 1
  ) {
    return true
  }
  // If there is no 3n+1 at the end, 3n-1 is big too
  // we subtract 2 because the first one is always big (outside the scrollable area)
  if (index > 1 && realLength % 3 !== 0 && index === realLength - 2) {
    return true
  }

  return false
}
